import { __makeTemplateObject } from "tslib";
import styled from '@emotion/styled';
// @ts-ignore
import { spacing } from '@metro-ui/tokens/js';
import { inputReadOnly } from '../../shared/styles';
export var Delimiter = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n\n  display: inline-block;\n  padding: 0 ", ";\n  text-align: center;\n"], ["\n  ", "\n\n  display: inline-block;\n  padding: 0 ", ";\n  text-align: center;\n"])), inputReadOnly, spacing['xxx-small']);
var templateObject_1;
//# sourceMappingURL=Delimiter.js.map